interface Props {
	bgColor: string;
	textColor: string;
	children: React.ReactNode;
}

const CustomBadge = ({ bgColor, textColor, children }: Props) => {
	const baseClasses = `
		tw:inline-flex
		tw:items-center
		tw:justify-center
		tw:pt-[0.4em]
		tw:pb-[0.4em]
		tw:pl-[0.7em]
		tw:pr-[0.7em]
		tw:text-xs
		tw:leading-none
		tw:whitespace-nowrap
		tw:rounded-[0.25em] 
		tw:bg-[var(--bg-color)]
		tw:text-[var(--text-color)]
		tw:font-[600]
	`;

	return (
		<span
			style={
				{
					'--bg-color': bgColor,
					'--text-color': textColor,
				} as React.CSSProperties
			}
			className={baseClasses}
		>
			{children}
		</span>
	);
};

export default CustomBadge;
